
import React from 'react'

const Orders = () => {
  return (
    <div><h3>Orders</h3><p>See your past orders here.</p></div>
  )
}

export default Orders